<section id="features" class="section features-area style-two overflow-hidden ptb_100">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-10 col-lg-6">
                <!-- Section Heading -->
                <div class="section-heading">
                    <span class="d-inline-block rounded-pill shadow-sm fw-5 px-4 py-2 mb-3">
                        <i class="far fa-lightbulb text-primary mr-1"></i>
                        <span class="text-primary">Premium</span>
                        Features
                    </span>
                    <h2>Express Functionality</h2>
                    <p class="d-none d-sm-block mt-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit.</p>
                    <p class="d-block d-sm-none mt-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati.</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4 my-3 res-margin">
                <!-- Image Box -->
                <div class="image-box text-center icon-1 p-5 wow fadeInLeft" data-aos-duration="2s" data-wow-delay="0.4s">
                    <!-- Featured Image -->
                    <div class="featured-img mb-3">
                        <img class="avatar-sm" src="assets/img/featured_image_1.png" alt="">
                    </div>
                    <!-- Icon Text -->
                    <div class="icon-text">
                        <h3 class="mb-2">Fully functional</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veritatis culpa expedita dignissimos.</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 my-3 res-margin">
                <!-- Image Box -->
                <div class="image-box text-center icon-1 p-5 wow fadeInUp" data-aos-duration="2s" data-wow-delay="0.2s">
                    <!-- Featured Image -->
                    <div class="featured-img mb-3">
                        <img class="avatar-sm" src="assets/img/featured_image_2.png" alt="">
                    </div>
                    <!-- Icon Text -->
                    <div class="icon-text">
                        <h3 class="mb-2">Live Chat</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veritatis culpa expedita dignissimos.</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 my-3 res-margin">
                <!-- Image Box -->
                <div class="image-box text-center icon-1 p-5 wow fadeInRight" data-aos-duration="2s" data-wow-delay="0.4s">
                    <!-- Featured Image -->
                    <div class="featured-img mb-3">
                        <img class="avatar-sm" src="assets/img/featured_image_3.png" alt="">
                    </div>
                    <!-- Icon Text -->
                    <div class="icon-text">
                        <h3 class="mb-2">Secure Data</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veritatis culpa expedita dignissimos.</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 my-3 res-margin">
                <!-- Image Box -->
                <div class="image-box text-center icon-1 p-5 wow fadeInLeft" data-aos-duration="2s" data-wow-delay="0.8s">
                    <!-- Featured Image -->
                    <div class="featured-img mb-3">
                        <img class="avatar-sm" src="assets/img/featured_image_4.png" alt="">
                    </div>
                    <!-- Icon Text -->
                    <div class="icon-text">
                        <h3 class="mb-2">Easy to Customize</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veritatis culpa expedita dignissimos.</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 my-3 res-margin">
                <!-- Image Box -->
                <div class="image-box text-center icon-1 p-5 wow fadeInUp" data-aos-duration="2s" data-wow-delay="0.4s">
                    <!-- Featured Image -->
                    <div class="featured-img mb-3">
                        <img class="avatar-sm" src="assets/img/featured_image_5.png" alt="">
                    </div>
                    <!-- Icon Text -->
                    <div class="icon-text">
                        <h3 class="mb-2">Responsive Design</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veritatis culpa expedita dignissimos.</p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4 my-3">
                <!-- Image Box -->
                <div class="image-box text-center icon-1 p-5 wow fadeInRight" data-aos-duration="2s" data-wow-delay="0.8s">
                    <!-- Featured Image -->
                    <div class="featured-img mb-3">
                        <img class="avatar-sm" src="assets/img/featured_image_6.png" alt="">
                    </div>
                    <!-- Icon Text -->
                    <div class="icon-text">
                        <h3 class="mb-2">Help Documentation</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veritatis culpa expedita dignissimos.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>